import { Box, Typography } from '@mui/material';

interface TermsSectionProps {
    terms: string[];
}

export const TermsSection = ({ terms }: TermsSectionProps) => {
    if (!terms || terms.length === 0) return null;

    return (
        <Box>
            <Typography sx={{ 
                fontSize: '0.7rem',
                fontWeight: 700,
                color: '#64748b',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: 2
            }}>
                📋 Terms & Conditions
            </Typography>
            <Box sx={{ 
                padding: 2.5,
                background: '#fafafa',
                border: '1px solid #e2e8f0',
                borderRadius: 2
            }}>
                {terms.map((term, index) => (
                    <Box 
                        key={index}
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 1.5,
                            marginBottom: index < terms.length - 1 ? 1.25 : 0
                        }}
                    >
                        <Typography sx={{ 
                            fontSize: '0.8rem',
                            color: '#94a3b8',
                            fontWeight: 600,
                            minWidth: '24px'
                        }}>
                            {index + 1}.
                        </Typography>
                        <Typography sx={{ 
                            fontSize: '0.85rem',
                            color: '#64748b',
                            lineHeight: 1.6,
                            flex: 1
                        }}>
                            {term}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
